import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { OptionsPropType } from '../../../shared/propTypes/common';
import { paramPropType } from '../../../shared/customReports/propTypes';
import { requiredWhenPresent } from '../../../shared/propTypes';

import FormikProvider from '../../../shared/forms/formikProvider.component';
import { CustomReportParamTypes } from '../../../shared/customReports/constants';

import EditCustomReportQueryParamModal from './editCustomReportQueryParamModal.component';

import schema from './customReportQueryParamForm.schema';


const EditCustomReportQueryParamModalContainer = ({
  entityToEdit,
  saveEntity,
  hideCustomReportModalForParam,
  reportParamToEditOptions,
  isVerifyingParamToEditQuery,
  isVisible,
  verifyParamOptionsQuery,
  testCustomReportQueryParamModalData,
  showTestCustomReportQueryParamModal,
  hideTestCustomReportQueryParamModal,
}) => {
  const createParam = useCallback(paramData => {
    switch (paramData.type) {
      case CustomReportParamTypes.query:
        return {
          label: paramData.label,
          mappingName: paramData.mappingName,
          name: paramData.name,
          query: paramData.query,
          type: paramData.type,
          value: paramData.value,
        };
      case CustomReportParamTypes.input:
        return {
          mappingName: paramData.mappingName,
          name: paramData.name,
          type: paramData.type,
        };
      case CustomReportParamTypes.validator:
        return {
          label: paramData.label,
          mappingName: paramData.mappingName,
          name: paramData.name,
          query: paramData.query,
          type: paramData.type,
          value: paramData.value,
        };
      default:
        return {};
    }
  }, []);

  const saveParamData = useCallback((paramData, { setSubmitting, resetForm }) => {
    const editedParam = createParam({
      ...paramData,
      name: entityToEdit.name,
    });

    saveEntity(editedParam);

    setSubmitting(false);
    hideTestCustomReportQueryParamModal();
    hideCustomReportModalForParam();
    resetForm();
  }, [createParam, entityToEdit, saveEntity, hideCustomReportModalForParam, hideTestCustomReportQueryParamModal]);


  const renderModal = useCallback(({ formik, schema }) => <EditCustomReportQueryParamModal
    formik={formik}
    schema={schema}
    hideCustomReportModalForParam={hideCustomReportModalForParam}
    verifyParamOptionsQuery={verifyParamOptionsQuery}
    isVisible={isVisible}
    isVerifyingParamToEditQuery={isVerifyingParamToEditQuery}
    reportParamToEditOptions={reportParamToEditOptions}
    testCustomReportQueryParamModalData={testCustomReportQueryParamModalData}
    hideTestCustomReportQueryParamModal={hideTestCustomReportQueryParamModal}
    showTestCustomReportQueryParamModal={showTestCustomReportQueryParamModal}
  />, [
    hideCustomReportModalForParam,
    verifyParamOptionsQuery,
    isVisible,
    isVerifyingParamToEditQuery,
    reportParamToEditOptions,
    testCustomReportQueryParamModalData,
    showTestCustomReportQueryParamModal,
    hideTestCustomReportQueryParamModal,
  ]);

  return (
    <FormikProvider
      schema={schema}
      entityToEdit={entityToEdit}
      onSubmit={saveParamData}
      render={renderModal}
    />
  );
};

EditCustomReportQueryParamModalContainer.propTypes = {
  entityToEdit: requiredWhenPresent(['isVisible'], paramPropType),
  saveEntity: PropTypes.func.isRequired,
  hideCustomReportModalForParam: PropTypes.func.isRequired,
  reportParamToEditOptions: OptionsPropType,
  isVerifyingParamToEditQuery: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  verifyParamOptionsQuery: PropTypes.func.isRequired,
  testCustomReportQueryParamModalData: PropTypes.func.isRequired,
  showTestCustomReportQueryParamModal: PropTypes.func.isRequired,
  hideTestCustomReportQueryParamModal: PropTypes.func.isRequired,
};

export default EditCustomReportQueryParamModalContainer;
